import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 .75v22.5M1.5 12.75 12 23.25l10.5-10.5"
    }, null, -1)
  ]));
}
const arrowDown = { render };
export {
  arrowDown as default,
  render
};
//# sourceMappingURL=arrow-down.svg.js.map
